


























































































































import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import {
  Catalogo,
  CatalogosService,
  FiltroCatalogo,
} from "@/services/catalogos.service";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Confirm from "@/shared/components/confirm.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import Manter from "./Manter.vue";
import { ServerPageOptions } from "@/shared/utils/datatable";
import { Paginacao } from "@/shared/interface";

@Component({ components: { DataTable, Tooltip, Manter, Confirm } })
export default class Catalogos extends mixins(GlobalMixin) {
  filtro: FiltroCatalogo = {
    term: "",
    somenteAtivos: false,
    offset: 0,
    limit: 100,
    order: "",
  };

  promise: Promise<Paginacao<Catalogo>> | null = null;

  headers = [
    { value: "prioridade", text: "Prioridade" },
    { value: "nome", text: "Catálogo" },
    { value: "descricao", text: "Descrição" },
    { value: "ativo", text: "Ativo" },
    { value: "revistaAtiva", text: "Revista Ativa", sortable: false },
    { value: "actions", text: "Ações", sortable: false },
  ];

  mounted() {
    this.filtro.term = "";
  }

  fetchCatalogos(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = CatalogosService.listarCatalogosGlobaisPaginado(this.filtro);
  }

  formatarPrioridade(catalogo: Catalogo) {
    return catalogo.prioridade ?? "-";
  }

  ehDestaque(catalogo: Catalogo) {
    return catalogo.prioridade === 0 || catalogo.prioridade === 1;
  }

  async novoItem() {
    const modal = this.$refs.manter as Manter;
    await modal.novoCatalogo();
    this.fetchCatalogos();
  }
  async editarItem(catalogo: Catalogo) {
    const modal = this.$refs.manter as Manter;
    await modal.editarCatalogo(catalogo.idCatalogo);
    this.fetchCatalogos();
  }
  async deletarItem(catalogo: Catalogo) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir catálogo ${catalogo.nome}`;
    const text = `Deseja realmente deletar o catálogo ${catalogo.nome} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await CatalogosService.deletarCatalogo(catalogo.idCatalogo).finally(
        this.stopLoader
      );
      this.fetchCatalogos();
    }
  }
}
